// reducers/LocalTrips/localTripsReducer.js

import { initialState } from "../../init/initialState";
import {
    GET_LOCAL_TRIPS_LIST,
    CLEAR_LOCAL_TRIPS_LIST,
    GET_LOCAL_TRIP_DETAIL,
    CLEAR_LOCAL_TRIP_DETAIL,
    CREATE_LOCAL_TRIP,
    CLEAR_CREATE_LOCAL_TRIP,
    GET_LOCAL_TRIP_REASONS,
    CLEAR_LOCAL_TRIP_REASONS,
    GET_LOCAL_TRIP_DECISIONS,
    CLEAR_LOCAL_TRIP_DECISIONS,
    CANCEL_LOCAL_TRIP,
    CLEAR_CANCEL_LOCAL_TRIP,
    APPROVE_LOCAL_TRIP,
    CLEAR_APPROVE_LOCAL_TRIP,
    GET_ERROR_LOCAL_TRIP,
    CLEAR_ERROR_LOCAL_TRIP, CLEAR_CREATED_LOCAL_TRIP,
} from "../../enums/LocalTrips/LocalTrips.types";

export const localTripsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOCAL_TRIPS_LIST:
            return {
                ...state,
                localTripsList: {
                    items: action.payload.items || [],
                    pagination: {
                        page: action.payload.pagination?.page || 1,
                        pageSize: action.payload.pagination?.pageSize || 20,
                        totalPages: action.payload.pagination?.totalPages || 1,
                        totalItems: action.payload.pagination?.totalItems || 0,
                    },
                },
                localTripError: null, // Очищаем ошибку при успешной загрузке
            };

    case CLEAR_LOCAL_TRIPS_LIST:
        return {
            ...state,
            localTripsList: null,
        };

    case GET_LOCAL_TRIP_DETAIL:
        return {
            ...state,
            localTripDetail: action.payload,
        };

    case CLEAR_LOCAL_TRIP_DETAIL:
        const tempDetail = { ...state };
        delete tempDetail.localTripDetail;
        return tempDetail;

    case CREATE_LOCAL_TRIP:
        return {
            ...state,
            createdLocalTrip: action.payload,
        };

    case CLEAR_CREATE_LOCAL_TRIP:
        const tempCreate = { ...state };
        delete tempCreate.createdLocalTrip;
        return tempCreate;

    case GET_LOCAL_TRIP_REASONS:
        return {
            ...state,
            localTripReasons: action.payload,
        };

    case CLEAR_LOCAL_TRIP_REASONS:
        const tempReasons = { ...state };
        delete tempReasons.localTripReasons;
        return tempReasons;

    case GET_LOCAL_TRIP_DECISIONS:
        return {
            ...state,
            localTripDecisions: action.payload,
        };

    case CLEAR_LOCAL_TRIP_DECISIONS:
        const tempDecisions = { ...state };
        delete tempDecisions.localTripDecisions;
        return tempDecisions;

    case CANCEL_LOCAL_TRIP:

            if (state.localTripsList && state.localTripsList.items) {
                return {
                    ...state,
                    localTripsList: {
                        ...state.localTripsList,
                        items: state.localTripsList.items.filter(trip => trip.id !== action.payload),
                    },
                };
            }
            return state;

    case CLEAR_CANCEL_LOCAL_TRIP:
        const tempCancel = { ...state };
        delete tempCancel.cancelledLocalTrip;
        return tempCancel;

    case APPROVE_LOCAL_TRIP:
        return {
            ...state,
            approvedLocalTrip: action.payload,
        };

    case CLEAR_APPROVE_LOCAL_TRIP:
        const tempApprove = { ...state };
        delete tempApprove.approvedLocalTrip;
        return tempApprove;

    case GET_ERROR_LOCAL_TRIP:
        return {
            ...state,
            localTripError: action.payload,
        };

    case CLEAR_ERROR_LOCAL_TRIP:
        const tempError = { ...state };
        delete tempError.localTripError;
        return tempError;
    case CLEAR_CREATED_LOCAL_TRIP:
        return {
            ...state,
            createdLocalTrip: null,
        };
    default:
        return state;
    }
};
